export var texts = {
  sendEmailText: {
    header: "To be extra safe, let's confirm it's really you ",
    description: 'We will send a one-time code to: ',
    buttonText: 'Send Code',
    footer: 'The one-time code expires in 5 minutes. Wrong email address? ',
    footerFAQ: 'Check our FAQs.'
  },
  validateCodeText: {
    header: 'Enter the code',
    description: 'Enter the one-time code we sent to ',
    buttonText: 'Confirm',
    footer: "Didn't receive your one-time code? Make sure it didn't go to your spam folder or ",
    footerSendAgain: 'send it again.'
  },
  errorMessages: {
    invalid_grant: "We don't recognize this code. Please double check.",
    expired_token: 'The session has timed out, ',
    downstream_server_issue: "It's not you, it’s us. Please try again later.",
    unknown_mfa_error: 'Something went wrong.',
    start_over_link_text: 'please start over.'
  }
};